<template>
  <div class="page">
    <el-card class="card-basic">
      <el-row :gutter="10" type="flex" class="row-bg">
        <el-col :span="1" style="line-height: 250%;">
          日期:
        </el-col>
        <el-col :span="8">
          <el-date-picker v-model="timeRange" type="daterange" align="right" unlink-panels value-format="yyyy-MM-dd"
            range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
          </el-date-picker>
        </el-col>
        <el-col :span="4">
          <el-radio-group v-model="msgType" @change="loadUserLog">
            <el-radio-button label="SMS">短信</el-radio-button>
            <el-radio-button label="MAIL">邮件</el-radio-button>
          </el-radio-group>
        </el-col>
        <el-col :span="1">
          <el-button type="primary" @click="loadUserLog">查询</el-button>
        </el-col>
      </el-row>
      <!-- <el-row>
        <el-col>
          <el-form class="card-form" :inline="true" :model="formInline">
            <el-form-item label="时间">
              <el-date-picker v-model="timeRange" type="daterange" align="right" unlink-panels value-format="yyyy-MM-dd"
                range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="用户名">
              <el-input clearable v-model="formInline.name" placeholder="用户名"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="drawer=true">添加预警</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row> -->
    </el-card>
    <el-card class="card-basic">
      <el-row>
        <el-col>
          <el-table border :data="filterTableData">
            <el-table-column label="序号" type="index" width="50"></el-table-column>
            <el-table-column prop="logTitle" label="站点" align="center"></el-table-column>
            <el-table-column prop="logUser" label="收件人" align="center"></el-table-column>
            <el-table-column prop="logContent" label="发送内容" align="center"></el-table-column>
            <el-table-column prop="logResult" label="发送结果" align="center"></el-table-column>
            <el-table-column prop="logTime" label="操作时间" align="center"></el-table-column>
          </el-table>
          <div style="text-align: right">
            <el-pagination @size-change="handleSizeChange" :current-page="currentPage"
              @current-change="handleCurrentChange" :page-sizes="[1, 2, 5, 10, 20, 50, 100]" :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper" :page-count="pageCount"></el-pagination>
          </div>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>
<script>
import { querySmsLogPromise } from "@/api/logApi";
import * as dayjs from "dayjs";
export default {
  data() {
    return {
      timeRange: [],
      pageSize: 10,
      currentPage: 0,
      logList: [],
      pageCount: 1,
      msgType: "SMS",
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = dayjs().add(1, "d").format("YYYY-MM-DD");
              const start = dayjs().subtract(7, "d").format("YYYY-MM-DD");
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = dayjs().add(1, "d").format("YYYY-MM-DD");
              const start = dayjs().subtract(30, "d").format("YYYY-MM-DD");
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = dayjs().add(1, "d").format("YYYY-MM-DD");
              const start = dayjs().subtract(90, "d").format("YYYY-MM-DD");
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      addFormInline: {
        type: []
      },
    };
  },
  mounted() {
    const start = dayjs()
      .subtract(15, "day")
      .format("YYYY-MM-DD");
    const end = dayjs().add(1, "day").format("YYYY-MM-DD");
    this.timeRange = [start, end];
    this.loadUserLog();
  },
  methods: {
    loadUserLog() {
      querySmsLogPromise({
        msgType: this.msgType,
        pageIndex: this.currentPage,
        pageSize: this.pageSize,
        start: this.timeRange[0],
        end: this.timeRange[1]
      }).then(res => {
        if (res.data.code === 200) {
          this.pageCount = parseInt(res.data.ext1);
          this.logList = res.data.content;
        } else {
          this.$message.warning(res.data.msg ? res.data.msg : "未加载到数据");
        }
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.loadUserLog();
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.loadUserLog();
    },
  },
  computed: {
    filterTableData() {
      const data = this.logList;
      // if (this.formInline.name) {
      //   data = data.filter(v =>
      //     v.name.toLowerCase().includes(this.formInline.name)
      //   );
      // }
      return data;
    }
  }
};
</script>
<style scoped>
.card-basic {
  margin: 5px 10px;
}
.card-form .el-form-item {
  margin-bottom: 0px;
}
</style>
